<template>
  <div class="delimiter" />
</template>

<style scoped lang='less'>
.delimiter {
  width: 100%;
  height: 12px;
  background: #FAFAFA;
}
</style>
